import React, { useState, useEffect } from 'react';
import { useAppSelector } from '../store/hooks';
import { Navigate, useSearchParams } from 'react-router-dom';
import AdminSessionSettings from '../components/admin/AdminSessionSettings';
import AdminSystemSettings from '../components/admin/AdminSystemSettings';
import AdminSecuritySettings from '../components/admin/AdminSecuritySettings';
import AdminNotificationSettings from '../components/admin/AdminNotificationSettings';
import AdminBankingSettings from '../components/admin/AdminBankingSettings';
import AdminAuditSettings from '../components/admin/AdminAuditSettings';
import './AdminDashboard.css';
import '../components/admin/AdminComponents.css';

const AdminSettings: React.FC = () => {
  const adminUser = useAppSelector(state => state.auth.adminUser);
  const isAuthenticated = useAppSelector(state => state.auth.isAuthenticated);
  const [activeTab, setActiveTab] = useState('session');

  if (!isAuthenticated || !adminUser) {
    return <Navigate to="/admin/login" replace />;
  }
  if (
    !adminUser.permissions ||
    !adminUser.permissions.includes('MANAGE_SETTINGS')
  ) {
    return <div style={{ color: 'red', textAlign: 'center', marginTop: 40 }}>You are not authorized to view this page.</div>;
  }

  const settingsTabs = [
    { id: 'session', label: 'Session & Auth', icon: '⏱️', component: AdminSessionSettings },
    { id: 'system', label: 'System Config', icon: '🔧', component: AdminSystemSettings },
    { id: 'security', label: 'Security', icon: '🔒', component: AdminSecuritySettings },
    { id: 'notifications', label: 'Notifications', icon: '🔔', component: AdminNotificationSettings },
    { id: 'banking', label: 'Banking Config', icon: '🏦', component: AdminBankingSettings },
    { id: 'audit', label: 'Audit & Logs', icon: '📊', component: AdminAuditSettings }
  ];

  const ActiveComponent = settingsTabs.find(tab => tab.id === activeTab)?.component || AdminSessionSettings;

  return (
    <div className="admin-settings">
      <div className="dashboard-header">
        <div className="dashboard-title">
          <h2>⚙️ Admin Settings</h2>
          <p>Configure system settings, security, and application preferences</p>
        </div>
      </div>
      
      {/* Settings Navigation Tabs */}
      <div className="settings-tabs">
        {settingsTabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
          >
            <span className="tab-icon">{tab.icon}</span>
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>
      
      {/* Content Body */}
      <div className="settings-content">
        <ActiveComponent />
      </div>
    </div>
  );
};

export default AdminSettings; 